import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { AlarmProfileEmailRecipientsDrawerModal } from "@src/components/organisms/modals/alarm-profile-email-recipients-drawer-modal/alarm-profile-email-recipients-drawer-modal";

export const AlarmProfileEmailRecipientsDrawer = () => {
  const showAlarmProfileEmailRecipientsDrawerModal = useSelector(
    (state: RootState) =>
      state.yourSlice.modals.alarmProfileEmailRecipientsDrawerModal.showModal,
  );

  return (
    <>
      {showAlarmProfileEmailRecipientsDrawerModal && (
        <AlarmProfileEmailRecipientsDrawerModal />
      )}
    </>
  );
};
